/*
 * @Description:
 * @Version:
 * @Autor: houcf
 * @Date: 2023-04-07 11:33:46
 * @LastEditTime: 2023-04-26 16:08:53
 */
// 倒计时
export function countDown(startTime, endTime, type) {
  var nowtime = new Date(), //获取当前时间
      endtime = new Date(endTime), //定义结束时间
      startTime = new Date(startTime);
  if (endtime < nowtime) { // 活动结束
      return {
          state: 2,
          time: null
      };
  }
  if (startTime > nowtime) { // 活动未开始
      endtime = new Date(startTime);
  }
  var lefttime = endtime.getTime() - nowtime.getTime(), //距离结束时间的毫秒数
      leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)), //计算天数
      lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24), //计算小时数
      leftm = Math.floor(lefttime / (1000 * 60) % 60), //计算分钟数
      lefts = Math.floor(lefttime / 1000 % 60); //计算秒数
  var result = {};
  if (startTime > nowtime) {
      result = {
          state: 3, // 1进行中 2结束 3 未开始
          time: (lefth > 0 ? leftd + 1 : lefth) + "天"
      }
  } else {
      result = {
          state: 1, // 1进行中 2结束 3 未开始
          time: type === 'day' ? leftd > 0 ? leftd + "天" : '' : (leftd > 0 ? leftd + "天" : '') + lefth + "时" + leftm + "分"

      }
  }
  return result; //返回倒计时的字符串
}
function zeroize(num) {
    return ('0' + num).slice(-2)
}
export const dateFormat = (time, format = 'YYYY-MM-DD hh:mm') => {
  if (!time) return ''
  if (/年|月|日/g.test(time)) {
      time = time.replace(/年|月/g, "-").replace(/日/g, "");
  }
  var timeDate = new Date(time);
  var year = timeDate.getFullYear();
  var month = timeDate.getMonth() + 1;
  var date = timeDate.getDate();
  var hours = timeDate.getHours();
  var minutes = timeDate.getMinutes();
  var seconds = timeDate.getSeconds();
  var newTime = format.replace(/YYYY/g, year).replace(/MM/, zeroize(month)).replace(/DD/, zeroize(date)).replace(/HH|hh/, zeroize(hours)).replace(/MM|mm/, zeroize(minutes)).replace(/SS|ss/, zeroize(seconds));
  return newTime;
}
export function getUrl(val) {
    if (val) {
        let url = '';
        if (val.substr(0, 7).toLowerCase() == "http://" || val.substr(0, 8).toLowerCase() == "https://") {
            url = val;
        } else {
            url = process.env.NODE_ENV === 'development' ? "http://192.168.1.216:8081/" + val :
                "https://www.cdpee.org.cn/" + val;
        }
        return url
    }
}
// 兼容薪资数据
export function getJobSalary(data) {
    let str = '';
    if (data.jobSalary == 30) {
        str = '面议';
    } else if (data.jobMinSalary || data.jobMaxSalary) {
        str = (data.jobMinSalary || '') + (data.jobMaxSalary ? (data.jobMinSalary ? '-' : '') + data.jobMaxSalary : '');
    } else {
        str = data.jobSalary || '面议';
    }
    return str;
}
